module.exports = __webpack_public_path__ + "media/images/alambique-mobile-132f26eacb8e5bac30d175207ef541df.jpg";